var _rect, _rect2, _path, _path2, _rect3, _text, _text2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSabrinaProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    fill: "#201E1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    fill: "url(#paint0_linear_1_2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 720L354 452L598 592L916 344L1200 548V900H0V720Z",
    fill: "#8C1A15",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 612L388 332L614 420L0 900V612Z",
    fill: "#AA241C",
    fillOpacity: 0.95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 100,
    width: 430,
    height: 430,
    stroke: "white",
    strokeWidth: 18,
    strokeOpacity: 0.86
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 760,
    fill: "white",
    fontFamily: "Roboto Slab, serif",
    fontSize: 150,
    fontWeight: 700
  }, "SM")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 818,
    fill: "#F5E7E0",
    fontFamily: "Roboto, sans-serif",
    fontSize: 34,
    letterSpacing: 4
  }, "ARQUITETA E URBANISTA")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 88,
    y1: 74,
    x2: 1116,
    y2: 812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171514"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabrinaProfile);
export default __webpack_public_path__ + "static/media/sabrina-profile.911346619cdfa64f428038b19f42a445.svg";
export { ForwardRef as ReactComponent };